<script setup>
  defineProps({
    title: {
      type: String,
      required: true,
    },
  });
</script>
<template>
  <article class="product-section">
    <header class="product-section__header">
      <h2 class="product-section__heading">
        {{ title }}
      </h2>
    </header>
    <slot />
  </article>
</template>
<style lang="scss" scoped>
  .product-section {
    width: 100%;

    &__header {
      margin-bottom: 1.5rem;
    }

    &__heading{
      font-size: 2rem;
    }
  }

  @media(max-width: 992px) {
    .product-section {
      &__header {
        margin-bottom: 0.675rem;
      }

      &__heading{
        font-size: 1.25rem;
      }
    }
  }
</style>
